/**
 * @generated SignedSource<<4fe0a9264f779c1c4ef1c10878d55376>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type NoteNative_note$data = {
  readonly editingMode: WidgetNoteEditingMode;
  readonly id: string;
  readonly isOrgNote: boolean;
  readonly pages: ReadonlyArray<{
    readonly backgroundColor: string | null;
    readonly id: string;
    readonly image: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePage_widgetNotePage">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "NoteNative_note";
};
export type NoteNative_note$key = {
  readonly " $data"?: NoteNative_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteNative_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteNative_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editingMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNotePage_widgetNotePage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "6db1868216c3894b1c681ff715d55cb2";

export default node;
